import './cart.css'

import { Button, Flex, GatsbyImage, Link, Text } from '@stars-ecom/shared-atoms-ui'
import { navigate } from 'gatsby'
import React from 'react'
import isNil from 'lodash/isNil'

import { DataLayerUtils } from '../context'
import { priceFormat } from '../utils'

const ProductsCartPopinExit = (props) => {
  const { mainColor="#fff", currentCart, onClose } = props
  const windowGlobal = typeof window !== 'undefined' && window

  const goToCheckout = () => {
    DataLayerUtils.addEvent({
      event: 'qwampEventLab',
      eventCat: 'Pages produit',
      eventAct: 'Popin panier exit page',
      eventLab: 'Départ panier'
    })
    navigate(`/checkout/onepage?previousUrl=` + windowGlobal?.location?.pathname)
  }

  const productHasPRIOffer = (product) => {
    if (
      !!product.productVariant && 
      !!product.productVariant.customFields.offers &&
      !!product.productVariant.customFields.offers.find(o => o.offerType1 === 'PRI')
    )
      return true;
    else 
      return false;
  }

  return (
    <Flex direction="column" p="15px 35px">
      {currentCart?.lines
        ?.filter((l) => l.productVariant?.product?.customFields?.productType === 'PDT')
        .slice(-2)
        .map((line) => (
          <Flex  key={`cart_line_popin_${line?.id}`}>
            <Flex flexDirection="row" w="100%" alignItems={'center'} justifyContent="space-evenly">
              {!isNil(line?.featuredAsset?.image?.childImageSharp?.gatsbyImageData) && (
                <GatsbyImage
                  image={line?.featuredAsset?.image?.childImageSharp?.gatsbyImageData}
                  loading="eager"
                  alt={line?.productVariant?.name}
                  style={{ width: '100px' }}
                />
              )}
              <Flex m="0 12px">
                <Link to={productHasPRIOffer(line) ? `${window.location.pathname}` : `/${line?.productVariant?.product?.customFields?.urlKey}`}>
                  <Text
                    fontSize="13px"
                    color="#000"
                    fontFamily="PT Sans,Arial,sans-serif"
                    w="160px"
                    _hover={{ textDecoration: 'underline' }}>
                    {line?.productVariant?.name}
                  </Text>
                </Link>
              </Flex>
              <Text
                w="70px"
                fontSize="14px"
                color="#000"
                fontWeight="700"
                fontFamily="PT Sans, Arial,sans-serif">
                {priceFormat(line?.linePriceWithTax, 'EUR', "Offert")}
              </Text>
            </Flex>
          </Flex>
        ))}
        <Button
          w="217px"
          m="30px auto 0"
          h="auto"
          color="#fff"
          bg={mainColor}
          p="14px 7px"
          fontSize="16px"
          fontFamily="PT Sans, Arial, sans-serif"
          fontWeight="normal"
          lineHeight="21px"
          borderRadius="none"
          borderColor={mainColor}
          borderStyle="solid"
          borderWidth="1px"
          _hover={{
            borderColor: '#c0c0c0',
            color: '#000',
            bg: '#fff'
          }}
          _focus={{ border: '0' }}
          onClick={() => {
            goToCheckout()
            onClose()
          }}
          id="popinGoToCart">
            Valider mon panier
        </Button>
    </Flex>
  )
}

export default ProductsCartPopinExit
